import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <Badge bg=...>.
const VARIANTS = {
  primary: "bg-integria-green text-white",
  secondary: "bg-gray-500 text-white",
  success: "bg-green-600 text-white",
  danger: "bg-red-600 text-white",
  warning: "bg-integria-yellow text-integria-green",
  info: "bg-sky-500 text-white",
  light: "bg-gray-100 text-gray-800",
  dark: "bg-gray-800 text-white",
}

export default function Badge({ bg = "secondary", className = "", children, ...props }) {
  const variant = VARIANTS[bg] || VARIANTS.secondary
  return (
    <span
      className={cn("inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold", variant, className)}
      {...props}
    >
      {children}
    </span>
  )
}
